import type { Theme } from "../..";
import type { UseThemeColorsProps } from "./types";

import { filterThemePrimitivesByColor } from "./utils";

/**
 * `useThemeColors()`
 *
 * This hook can be used to get all color primitives from the given theme.
 * If theme is not specified, it will return color primitives for all themes.
 */
function useThemeColors(
	themeFile: Theme.GriddoTheme,
	props?: UseThemeColorsProps,
) {
	const themes: Array<Theme.GlobalTheme | Theme.Theme> = [];

	if (props?.global) {
		themes.push(themeFile.global);
	}

	if (props?.theme) {
		const selectedTheme = themeFile.themes.find((t) => t.id === props.theme);
		selectedTheme && themes.push(selectedTheme);
	} else {
		themes.push(...themeFile.themes);
	}

	const themesWithColors = filterThemePrimitivesByColor(
		themes,
		props?.subtheme,
	);
	return themesWithColors;
}

export { useThemeColors };
